module.exports = __webpack_public_path__ + "img/nature-2.6cb84c71.jpg";